import React from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";
import Button from "../components/buttons/Button";
import filedIcon from "../assets/icons/fitenote-sidebar-active-icon.svg";
import { FiDownloadCloud } from "react-icons/fi";

function ImportFileFrame(props) {
  const { name, accept, className, file, onFileSelected } = props;
  const onDrop = React.useCallback(
    (acceptedFile) => {
      if (acceptedFile.length > 0) {
        const file = acceptedFile[0];
        onFileSelected(file);
      }
    },
    [onFileSelected]
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });
  var classNameStyles = className ? className : "";
  var acceptCsvFile = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
  var acceptConfig = accept ? accept : acceptCsvFile;

  return (
    <div
      {...getRootProps()}
      className={`${classNameStyles} upload-file__frame`}
    >
      <div className="flex justify-center">
        <input {...getInputProps()} name={name} accept={acceptConfig} />
        {file ? (
          <div className="flex justify-center items-center">
            <img
              src={filedIcon}
              alt="file-icon"
              className="md:w-12 md:h-12 2xl:w-16 xl:w-14 xl:h-16"
            />
            <div>
              <p>{file.path}</p>
              <p>{(file.size / (1024 * 1024)).toFixed(2)} MB</p>
            </div>
          </div>
        ) : (
          <FiDownloadCloud size="60" color="#BDBDBD" />
        )}
      </div>

      <p className="font-normal xl:text-[18px] lg:text-base text-[15px] text-center">
        ここにファイルをドラッグ＆ドロップ
      </p>
      <p className="font-light xl:text-[16px] text-[15px] text-center">
        または
      </p>
      <div className="flex justify-center">
        <Button
          type="button"
          color="purple"
          className="upload-file__btn min-w-[160px] max-w-[200px] w-full"
        >
          ファイルを選択
        </Button>
      </div>
    </div>
  );
}

export default ImportFileFrame;

ImportFileFrame.propTypes = {
  name: PropTypes.string.isRequired,
  accept: PropTypes.string,
  fileSize: PropTypes.string,
  multiple: PropTypes.bool,
  className: PropTypes.string,
  file: PropTypes.object,
};
